const setAnswer = function (qu, valueMap, otherAnswerMap) {
  const scoreQuType = this.scoreQuType
  let id = this.id
  let value = valueMap[id]
  if (scoreQuType === '1' || scoreQuType === '5') {
    value = value || ''
  } else if (scoreQuType === '2') {
    value = Number(value)
  } else {
    value = value || null
  }
  if (value instanceof Array) {
    value = value.join('')
  }
  this.tmpValue = value
  this.value = value
}

const answer = {
  setAnswer
}

export default answer



// WEBPACK FOOTER //
// ./src/components/editor/RateBox/answer.js